export const SUCCESS_PURCHASE_STATUS = 'success';
export const PENDING_PURCHASE_STATUS = 'pending';
export const ERROR_PURCHASE_STATUS = 'error';
